<template>
  <div class="login-container">
    <div class="logo-container">
      <img class="inline-block" src="@/assets/logo2.jpg" alt="Logo" width="100%" />
    </div>
    <!-- <div class="font-bold text-3xl">تسجيل الدخول</div> -->
    <form @submit.prevent="login">
      <!-- <label for="username">اسم المستخدم</label> -->
      <input class="text-center mt-6 " v-model="username" type="text" id="username" placeholder="الايميل" required
        oninvalid="this.setCustomValidity('الرجاء ادخال الايميل')" oninput="setCustomValidity('')"
        @input="validateEmail" />
      <span class="text-center text-red-500 text-xs" v-if="emailError">{{ emailError }}</span>

      <!-- <label for="password">الرقم السري</label> -->
      <input class="text-center mt-6 " v-model="password" type="password" id="password" placeholder="الرقم السري"
        required oninvalid="this.setCustomValidity('الرجاء ادخال الرقم السري')" oninput="setCustomValidity('')" />

      <div class="text-center text-red-500 text-xs" v-if="errorMessageVisible">
        {{ errorMessage }}</div>

      <button class="button-style mt-6 " type="submit">تسجيل الدخول</button>
    </form>
  </div>
</template>

<script>
import axios from 'axios';
import url from '@/url';
export default {
  data() {
    return {
      username: '',
      password: '',
      errorMessageVisible: false,
      messageText: "",
      emailError: "",
    };
  },
  methods: {
    async login() {
      try {
        const response = await axios.post(url.login,
          {
            email: this.username,
            password: this.password,
          },
          {
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
              'Content-Type': 'application/json',
            },
          }
        );
        console.log(response)
        if (response != undefined && response.data.data.token != undefined) {
          // Check if the user has admin, general manager, or super admin role
          const userRole = response.data.data.role;
          
          if (userRole !== 'ADMIN' && userRole !== 'GENERAL_MANAGER' && userRole !== 'SUPER_ADMIN') {
            this.errorMessageVisible = true;
            this.errorMessage = 'غير مسموح لك بالدخول لهذا النظام. هذا النظام مخصص للإداريين فقط.';
            return;
          }

          // Assuming the API returns a token upon successful login
          const token = response.data.data.token;
          const refreshToken = response.data.data.refreshToken;

          console.log('Token:', token);
          console.log('refreshToken:', refreshToken);

          localStorage.setItem("token", token);
          localStorage.setItem("refreshToken", refreshToken);
          localStorage.setItem("userRole", userRole);

          // Fetch user permissions after login
          try {
            const permissionsResponse = await axios.get(
              process.env.VUE_APP_SERVICE_URL + '/api/v1/admin/permissions/me',
              {
                headers: {
                  'X-Authorization': token,
                },
              }
            );
            
            if (permissionsResponse.data && permissionsResponse.data.result && permissionsResponse.data.result.data) {
              const permissions = permissionsResponse.data.result.data.permissions || {};
              localStorage.setItem('permissions', JSON.stringify(permissions));
            } else if (permissionsResponse.data && permissionsResponse.data.data) {
              const permissions = permissionsResponse.data.data.permissions || {};
              localStorage.setItem('permissions', JSON.stringify(permissions));
            }
          } catch (error) {
            console.error('Error fetching permissions:', error);
            // Continue even if permissions fetch fails
          }

          // Redirect super admin to general report, others to dashboard
          if (userRole === 'SUPER_ADMIN') {
            this.$router.push({ name: 'SuperAdminGeneralReport' });
          } else {
            this.$router.push({ name: 'Dashboard' });
          }
        }
        // Redirect or perform other actions based on the response
      } catch (error) {
        if (error.response != undefined && error.response.data != undefined && error.response.data.messageAr != undefined) {
          this.errorMessageVisible = true;
          this.errorMessage = error.response.data.messageAr;
        } else {
          alert('حدث خطأ ما الرجاء المحاولة مرة اخرى');
        }
      }
    },
    validateEmail() {
      // Regular expression for basic email validation
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (!emailRegex.test(this.username)) {
        this.emailError = "الرجاء ادخال الايميل بشكل صحيح";
      } else {
        this.emailError = "";
      }
    },
  },
};
</script>

<style scoped>
.login-container {
  max-width: 500px;
  margin: auto;
  padding: 20px;
  @apply border border-gray-200 rounded-lg shadow-lg bg-white;
  margin-top: 230px;
}

.logo-container {
  text-align: center;
  margin-bottom: 20px;
}

img {
  max-width: 100px;
  /* Adjust the size as needed */
  max-height: 100px;
}

form {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

label {
  font-weight: bold;
}

input {
  padding: 8px;
  @apply border border-gray-300 rounded;
}

button {
  padding: 10px;
  @apply text-white border-0 cursor-pointer bg-primary rounded-full;
}

button:hover {
  @apply bg-hafadh-olive-dark;
}
</style>